<div class="envkv-values" *ngIf="data">
    <div class="envkv-text" [ngClass]="{closed: addClass}" [innerHTML]="data | safeHtml"></div>
    <div class="envkv_arrow" [ngClass]="{show: _showArrow, closed: addClass}" (click)="toggleClose()">
        <svg xmlns="http://www.w3.org/2000/svg" id="a" viewBox="0 0 22 22" width="24" height="24" class="lazyloaded">
            <path d="M11,22C4.93,22,0,17.07,0,11S4.93,0,11,0s11,4.93,11,11-4.93,11-11,11ZM11,1C5.49,1,1,5.49,1,11s4.49,10,10,10,10-4.49,10-10S16.51,1,11,1Zm0,13.31l-.32-.32h0s-4.68-4.68-4.68-4.68l.62-.62,4.38,4.38,4.38-4.38,.62,.62-5,5Z" style="fill:#000;"></path>
        </svg>
    </div>
</div>
